import { render, staticRenderFns } from "./r-plinko-obstacle-config-table.vue?vue&type=template&id=663f2ce5"
import script from "./r-plinko-obstacle-config-table.vue?vue&type=script&lang=js"
export * from "./r-plinko-obstacle-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('663f2ce5')) {
      api.createRecord('663f2ce5', component.options)
    } else {
      api.reload('663f2ce5', component.options)
    }
    module.hot.accept("./r-plinko-obstacle-config-table.vue?vue&type=template&id=663f2ce5", function () {
      api.rerender('663f2ce5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-obstacle-config-table.vue"
export default component.exports